<ng-container *ngIf="!(modalName === 'reImportApi'&& webSocketService.ws.stepCount == 3)">
  <wms-dialog-header *ngIf="modalName === 'ImportApi'" (onClose)="closeAllDialogs()"
    title="{{ locale.LABEL_IMPORT_APIS }}" helpTitle="{{ locale.LABEL_WEB_SERVICE }}"
    helpLink="https://docs.wavemaker.com/learn/app-development/services/api-designer/import-rest-apis-swagger/">
  </wms-dialog-header>

  <wms-dialog-header *ngIf="modalName === 'reImportApi'" (onClose)="closeAllDialogs()"
    title="{{locale.LABEL_RE_IMPORT_APIS}}" helpTitle="{{ locale.LABEL_WEB_SERVICE }}"
    helpLink="https://docs.wavemaker.com/learn/app-development/services/api-designer/import-rest-apis-swagger/">
  </wms-dialog-header>

  <wms-dialog-body>
    <div class="app-dialog-body modal-body rest-import-dialog" name="wm-WebServiceCreation-content">
      <div *ngIf="showDialog === 'importDialog' && modalName === 'ImportApi'" ng-controller="WebServiceController"
        class="ng-scope">
        <div class="web-services-container cmnflx">
          <div class="clearfix ng-scope rowDirection">
            <div (click)="openService('APIBundle')" name="wm-webservice-soap"
              class="webservice-tile text-center ng-scope web-service-tiles">
              <img class="web-service-image marginBottom15" [src]="baseURL + 'apibundledialogscreen.png'" />
              <div class="webservice-tile-caption text-center columnDirection">
                <span class="ng-binding font700">
                  {{ locale.LABEL_API_BUNDLES }}</span>
                <span class="ng-binding">
                  {{ locale.LABEL_OPENAPI_SWAGGER }}</span>
              </div>
            </div>
            <div name="wm-webservice-rest" class="webservice-tile text-center ng-scope web-service-tiles"
              (click)="openService('restImportModal')">
              <img class="web-service-image marginBottom15" [src]="baseURL + 'restapidialogscreen.png'" />
              <div class="webservice-tile-caption text-center">
                <span class="ng-binding font700">
                  {{ locale.LABEL_REST_APIS }}</span>
              </div>
            </div>
            <div *ngIf="!projectService.isNativeMobileApplicationType()" name="wm-webservice-websocket" class="webservice-tile text-center ng-scope web-service-tiles"
              (click)="openService('WEBSOCKET')">
              <!-- <div class="wms-icon wms-webservice web-service-image marginBottom15 WEBSOCKET"></div> -->
               <div class="websocket-img-align web-service-image">
                <img class="" [src]="baseURL + 'websocketdialogscreen.png'" />
               </div>
              <div class="webservice-tile-caption text-center">
                <span class="ng-binding font700">
                  {{ locale.LABEL_WEB_SERVICE_TITLE_WEBSOCKET }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showDialog === 'APIBundle' || modalName === 'reImportApi'" class="web-services-container">
        <div class="wm-form openapi">
          <div class="soap-service-container">
            <div *ngIf="modalName === 'reImportApi' && webSocketService.ws.stepCount === 1">
                <h5 class="no-border"> {{reImportMsg}}
                </h5>
              <div class="app-message text-message">
                <span class="iconClass"> <i class="wms wms-info-outline"></i></span>
                <p class="messageClass">{{locale.MESSAGE_APPLICATION_DISRUPTION}}
                  <a target="_blank"
                    href="https://docs.wavemaker.com/learn/blog/2021/09/17/git-branching-strategy/">{{locale.MESSAGE_GIT_BRANCHING}}</a>
                  {{locale.MESSAGE_CODE_EFFECTIVELY}}</p>
              </div>
            </div>

            <wms-message *ngIf="toggleMessage" [scopeDataset]="toggleMessage"></wms-message>
            <div *ngIf="webSocketService.ws.stepCount === 2" class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-md-1 open-api-service-label">{{ locale.LABEL_SERVICE_NAME }}:
              </label>
              <div class="col-md-11 open-api-service-container">
                <input *ngIf="modalName === 'ImportApi'" name="wm-webservice-openapi-id-input"
                  class="form-control app-textbox" type="text" [(ngModel)]="webSocketService.ws.customServiceName"
                  placeholder="{{locale.PLACEHOLDER_SERVICE_NAME}}">
                <input *ngIf="modalName === 'reImportApi'" name="wm-webservice-openapi-id-input"
                  class="form-control app-textbox" type="text" disabled="disabled"
                  [(ngModel)]="apiService.activeApi.serviceId" placeholder="{{locale.PLACEHOLDER_SERVICE_NAME}}">
                <i title="{{locale.MESSAGE_HELP_OPEN_API_SERVICE_NAME}}" class="wms wms-help"></i>
              </div>
            </div>
            <h5 *ngIf="modalName === 'ImportApi' && webSocketService.ws.stepCount === 2" class="no-border">
              {{ locale.LABEL_OPEN_API_ENTITY_MSG }}
            </h5>
            <div *ngIf="modalName === 'reImportApi' && webSocketService.ws.stepCount === 2 && compatibilityMessage.show" class="alert app-message alert-warning compatibility-message">
              <div><i title="warn Alert" class="warn icon wi wi-bell"></i></div>
              <div [innerHTML]="compatibilityMessage.caption"></div>
              <div><button title="Close" type="button" class="btn-transparent close" (click)="compatibilityMessage.show = false">&times;</button></div>
            </div>
            <wms-message *ngIf="modalName === 'reImportApi' && webSocketService.ws.stepCount === 2" [scopeDataset]="swaggerMessage"></wms-message>
            <h5 *ngIf="modalName === 'reImportApi' && webSocketService.ws.stepCount === 2 && !swaggerMessage" class="no-border-text">
              <i class="wms wms-error-triangle"></i>
              <span *ngIf="tagsCount?.effectedPaths !== 0">
              {{tagsCount?.effectedPaths}} {{locale.MESSAGE_ENDPOINT_MODIFIED}} {{tagsCount?.totalPages}}
              {{locale.MESSAGE_RE_IMPORT_API_PAGE}} {{tagsCount?.totalIssues}} {{locale.MESSAGE_ERRORS}}</span>
              <span *ngIf="tagsCount?.effectedPaths === 0">{{locale.MESSAGE_SUCESS_NO_ISSUES_FOUND}}</span>
            </h5>
            <div *ngIf="webSocketService.ws.stepCount === 1" class="file-upload">
              <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-md-2 required">{{ locale.LABEL_SWAGGER_FILE }}:
                </label>
                <div class="col-md-10">
                  <div class="col-md-12">
                    <div class="btn-group wm-button-group">
                      <label class="btn btn-default" [(ngModel)]="webSocketService.ws.swaggerSource" (change)="toggleMessage(false)"
                        (click)="setActiveClass(false); webSocketService.ws.swaggerSource = 'URL'" btnRadio="URL" tabindex="0"
                        role="button">{{ locale.LABEL_PROPERTY_URL }}</label>
                      <label class="btn btn-default" [(ngModel)]="webSocketService.ws.swaggerSource" (change)="toggleMessage(false)"
                        (click)="setActiveClass(true); webSocketService.ws.swaggerSource = 'FILE'" btnRadio="File" tabindex="0"
                        role="button">{{ locale.LABEL_FILE }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group app-composite-widget clearfix">
                <div class="col-md-10 col-md-offset-2">
                  <!-- TO DO - Needed? -->
                  <!-- <span (click)="downloadFile('bindingsXML')" *ngIf="webSocketService.ws.swaggerSource == 'FILE' && webSocketService.ws.wsdlFileName">
                            <input name="wm-webservice-swagger-source-filename-input"
                                class="form-control app-textbox bound-input" type="text" disabled="disabled"
                                [(ngModel)]="webSocketService.ws.bindingsFileName" readonly="readonly">
                            <i (click)="resetFile($event, 'bindingsXML')" class="wms wms-clear"></i>
                        </span> -->
                <input
                  name="wm-webservice-soap-source-url-input"
                  class="form-control app-textbox open-api-input-url"
                  type="text"
                  placeholder="{{ locale.MESSAGE_SWAGGER_PLACEHOLDER }}"
                  [(ngModel)]="webSocketService.ws.swaggerSourceUrl"
                  *ngIf="webSocketService.ws.swaggerSource == 'URL'"
                />
                <input
                  name="wm-webservice-soap-source-file-input"
                  type="file"
                  class="col-md-8"
                  *ngIf="webSocketService.ws.swaggerSource == 'FILE'"
                />
                <i
                  title="{{ locale.MESSAGE_HELP_SWAGGER_SRC }}"
                  class="wms wms-help"
                ></i>
              </div>
            </div>
          </div>
          <div
            *ngIf="webSocketService.ws.stepCount === 2"
            class="wm-api-designer wm-open-api-designer"
          >
            <div class="api-list">
              <div class="fixed-header">
                <h3 class="end-points">{{ locale.LABEL_ENTITIES }}</h3>
              </div>
              <div class="list">
                <div>
                  <ul class="end-points-list">
                    <li
                      *ngFor="let entity of webSocketService.ws.entities"
                      [ngClass]="{
                        active: entity.name === webSocketService.ws.activeEntity.name
                      }" (click)="setActiveEntity(entity)">
                        {{ entity.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div name="wm-webservice-entity" class="api-viewer custom-api-viewer open-api-entity">
                <wms-swagger-ui></wms-swagger-ui>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showDialog === 'restImportModal'" class="web-services-container">
        <wms-rest-import-ui [restImportDomID]="restImportDomID" [restImportViewMode]="restImportViewMode"
          [codeEditorValue]="responseBody" #restImportUI></wms-rest-import-ui>
      </div>
      <div *ngIf="showDialog === 'WEBSOCKET'" class="web-services-container">
        <wms-websocket  [viewMode]="'create'" [wizardSteps]="wizardSteps" #webSocketUI></wms-websocket>
      </div>
    </div>
  </wms-dialog-body>
  <wms-dialog-footer>
    <div class="rowDirection alignEnd">
      <button name="wm-webservice-cancel" class="btn button-secondary app-button marginRight"
        (click)="closeAllDialogs()" [disabled]="disableBtn">
        {{ locale.LABEL_CANCEL }}
      </button>
      <div *ngIf="showDialog === 'APIBundle' || modalName === 'reImportApi' || showDialog === 'WEBSOCKET'">
        <button name="wm-webservice-back" class="button-tertiary btn app-button"
          (click)="webSocketService.ws.stepCount === 1 ? goBack() : backButton()" [disabled]="disableBtn" name="wm-webservice-back">
          {{ locale.LABEL_BACK }}
        </button>
        <button *ngIf="webSocketService.ws.stepCount == 1" class="btn btn-primary" (click)="configureService(showDialog === 'WEBSOCKET' ? 'WEBSOCKET' : '')" [disabled]="showDialog === 'WEBSOCKET' ? webSocketService?.disableDialogActions || (showDialog === webSocketService.ws.serviceType.WEBSOCKET && !webSocketService.ws.testNotRequired && !webSocketService.ws.serviceTested) : disableBtn"
          name="wm-webservice-sample-next">
          {{ locale.LABEL_NEXT }}
        </button>
        <button *ngIf="modalName === 'ImportApi' && webSocketService.ws.stepCount === 2" name="wm-webservice-import"
          class="button-primary btn app-button" [disabled]="showDialog === 'WEBSOCKET' ? webSocketService?.disableDialogActions : hasSwaggerName() || disableBtn" (click)="importService(showDialog === 'WEBSOCKET' ? 'WEBSOCKET' : '')">
          {{ locale.LABEL_IMPORT }}
        </button>
        <button *ngIf="modalName === 'reImportApi' && webSocketService.ws.stepCount == 2" class="btn btn-primary"
          (click)="reImportDialog('reImportLoader')" [disabled]="disableBtn" name="wm-webservice-sample-next">
          {{ locale.LABEL_NEXT }}
        </button>
      </div>
      <div *ngIf="showDialog === 'restImportModal'">
        <button class="button-tertiary btn app-button" (click)="goBack()" [disabled]="disableBtn">
          {{ locale.LABEL_BACK }}
        </button>
        <button class="btn btn-primary app-button" (click)="handleImportClick()"
          [disabled]="restImportComponentUI?.restImportData?.importDisabled()">
          {{locale.LABEL_IMPORT}}
        </button>
      </div>
    </div>
  </wms-dialog-footer>

</ng-container>

<ng-container *ngIf="modalName === 'reImportApi'&& webSocketService.ws.stepCount == 3 " #reImportLoader>
  <wms-reimport-api [tagsCount]="tagsCount" [disableBtn]="disableBtn" [ws]="webSocketService.ws" [reimportInProgress]="reimportInProgress" (reimportServiceapi)="reimportServiceapiData()"></wms-reimport-api>
</ng-container>
